module.exports = __webpack_public_path__ + "static/media/InviteUser.87693f23.svg";